import React, { useEffect, useRef, useState } from "react";

import { RadioGroupProps } from "antd";

import { Flex, Radio, TooltipWrapper, Typography } from "components";

export type RadioPillGroupProps = Omit<RadioGroupProps, "options"> & {
  type?: "primary" | "secondary" | "tertiary" | "other";
};

export type RadioPillProps = {
  additionalInfo?: string;
  className?: string;
  dataTestId?: string;
  disabled?: boolean;
  label?: string;
  value: string | number;
};

export const RadioPillGroup = ({ children, className, ...props }: RadioPillGroupProps) => (
  <Radio.Group {...props} className={`${className} radio-pill radio-group`}>
    <Flex wrap="wrap" gap="0.5rem">
      {children}
    </Flex>
  </Radio.Group>
);

export const RadioPill = ({ additionalInfo, className, dataTestId, disabled = false, label, value }: RadioPillProps) => {
  const [shouldShowTextTooltip, setShouldShowTextTooltip] = useState(false);

  const nameContainerRef = useRef<HTMLParagraphElement | null>(null);
  const nameRef = useRef<HTMLParagraphElement | null>(null);

  useEffect(() => {
    const nameContainerElement = nameContainerRef.current;
    const nameElement = nameRef.current;
    if (!nameContainerElement || !nameElement) return;

    const handleResize = () => {
      setShouldShowTextTooltip(nameContainerElement!.offsetWidth < nameElement!.offsetWidth);
    };

    const observer = new ResizeObserver(handleResize);

    const cardElements = [nameContainerElement, nameElement];
    // start the observer of each card ref
    cardElements.forEach((element) => {
      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Radio className={`${className} radio-pill radio-group item`} data-testid={dataTestId} disabled={disabled} value={value}>
      <Flex justify="space-between" align="center" gap="0.25rem">
        <TooltipWrapper
          tooltip={
            shouldShowTextTooltip
              ? {
                  title: label,

                  placement: "top",
                }
              : {}
          }
        >
          <div ref={nameContainerRef} data-testid={`${dataTestId}-name`} className={`${className} label margin-0`} style={{ flex: 1 }}>
            <span ref={nameRef}>{label}</span>
          </div>
        </TooltipWrapper>
        {additionalInfo && (
          <Typography variant="paragraph-m" data-testid={`${dataTestId}-avgPayout`} className={`${className} additional-info`}>
            {additionalInfo}
          </Typography>
        )}
      </Flex>
    </Radio>
  );
};
